var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',_vm._l((3),function(i){return _c('v-col',{key:i,attrs:{"cols":"12"}},[_c('v-skeleton-loader',_vm._b({attrs:{"type":"list-item-three-line"}},'v-skeleton-loader',_vm.attrs,false))],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }